import { useRef } from 'react'
import clsx from 'clsx';
import Lottie from 'lottie-react';
import success from '../../../../../../assets/lottie/success.json'
import { Button } from '../../../../../atoms/Button/StyledButton';
import './EndStepper.css'
import { LoginType } from 'components/types/Context';
import { useNavigate } from 'react-router-dom';

interface EndStepperProps {
    loginType: LoginType,
    [key: string]: any
}

export const EndStepper = (props: EndStepperProps) => {
    const navigate = useNavigate();

    const lottieRef = useRef<any>();
    const buttonText = props.loginType === LoginType.startup
        ? 'plans for startups'
        : 'login';
    const buttonOnClick = props.loginType === LoginType.startup
        ? () => window.location.replace("https://www.innovationmatch.io/for-startups/")
        : () => navigate('/login', { state: props.loginType });

    return (
        <div
            className={clsx(
                'd-flex align-items-center justify-content-center  response_message w-100 ',
                { 'd-none': !props.isActive },
            )} >
            <div className='container-success  w-100'>
                <div className='position-relative  d-flex align-items-center justify-content-center  w-100'>
                    <Lottie
                        lottieRef={lottieRef}
                        animationData={success}
                        loop
                        className={'success_anim  '}
                    />
                    <div className='position-absolute w-100 p-2 top-50-perc  '>
                        <h4 className=' text-center'>
                            Your registration was successful!

                            {props.loginType === LoginType.startup
                                ? " Wait to be contacted by email to have your account activated"
                                : " Log in with your chosen credentials"
                            }

                        </h4>
                        <div className='d-flex justify-content-center mt-5'>
                            <Button
                                onClick={buttonOnClick}
                                type="submit" className='mt-1' color='var(--white)' background='var(--primary)' borderColor='var(--primary)' fontWeight={'800'} uppercase primary
                                text={buttonText} />


                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

